/**
 * Register Page
 * Beautiful auth page based on Figma design system
 */
import { AuthPage } from '../../components/auth/AuthPage';

const RegisterPage = () => {
  return <AuthPage />;
};

export default RegisterPage;

